import $ from 'jquery';

// Overwrites the text inside an element without removing its icon.
export const updateTextOnly = (element, textContent) => {
  const $element = $(element);

  if ($element.length > 0) {
    const icon = $element.find('i');
    if (icon.attr('trailing_icon')) {
      $element.text(textContent).append(icon);
    } else {
      $element.text(textContent).prepend(icon);
    }
  }

  return $element;
};
